import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemVoucherMaybe = props => {
  const { lineItems, isProvider, intl } = props;

  // Find voucher line items (both 'line-item/voucher' and 'line-item/wallet-credit')
  const voucherItems = lineItems.filter(
    item =>
      (item.code === 'line-item/voucher' || item.code === 'line-item/wallet-credit') &&
      !item.reversal
  );

  const items = isProvider
    ? voucherItems.filter(item => item.includeFor.includes('provider'))
    : voucherItems.filter(item => item.includeFor.includes('customer'));

  return items.length > 0 ? (
    <React.Fragment>
      {items.map((item, i) => {
        const formattedTotal = formatMoney(intl, item.lineTotal, true);
        
        // Use "Discount" for vouchers, "Credit" for wallet
        const labelKey = item.code === 'line-item/wallet-credit' 
          ? 'General.credit' 
          : 'General.voucher';

        return (
          <div key={`${i}-${item.code}`} className={css.lineItem}>
            <span className={css.itemLabel}>
              <FormattedMessage id={labelKey} />
            </span>
            <span className={css.itemValue}>{formattedTotal}</span>
          </div>
        );
      })}
    </React.Fragment>
  ) : null;
};

LineItemVoucherMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  isProvider: bool,
  intl: intlShape.isRequired,
};

export default LineItemVoucherMaybe;
